import { createEffect, createEvent, createStore, sample } from 'effector';
import { deleteRequested, libraryRequested, listProjectsFx } from '../../entities/library';
import { safeLocalStorage } from '../../shared/lib/safe-storage';
import { routes } from '../../shared/routing';

export const projectDeleteConfirmed = createEvent<string>();

sample({ clock: routes.home.opened, target: libraryRequested });
// Synced projects also move to the account's trash.
sample({ clock: projectDeleteConfirmed, target: deleteRequested });

/*
 * First visit (docs/PLAN.md §2.5): with no projects yet, a sample project is created and opened,
 * once. Automated browsers (navigator.webdriver) start empty, so tests stay deterministic.
 */
const SAMPLE_KEY = 'finsim:sample-created';
export const sampleCreated = createEvent();
export const $sampleWanted = createStore(false)
  .on(
    listProjectsFx.doneData,
    (_, list) =>
      list.length === 0 && !navigator.webdriver && safeLocalStorage.getItem(SAMPLE_KEY) !== '1',
  )
  .reset(sampleCreated);
const rememberSampleFx = createEffect(() => {
  safeLocalStorage.setItem(SAMPLE_KEY, '1');
});
sample({ clock: sampleCreated, target: rememberSampleFx });
